import React from 'react';
import PropTypes from 'prop-types';
import { formatDateUTC } from 'utils/Formatters';
import classNames from 'classnames';
import ASQSectionResults from './ASQSectionResults';
import ArchivedBadge from 'components/helpers/ArchivedBadge';
import i18n from '../../utils/i18n';

const STATUS_COLORS = {
  completed: '#27ae60',
  pending:   '#e67e22',
  started:   '#2980b9',
  archived:  '#999',
  completed_rescreen: '#27ae60',
};

const surveyStatusLabel = (pq) => {
  if (pq.state === 'archived') return { label: i18n.t('playerSurvey.archived', { defaultValue: 'Archived' }), color: STATUS_COLORS.archived };
  if (pq.state === 'completed') {
    const key = pq.rescreened ? 'completed_rescreen' : 'completed';
    const defaultValue = pq.rescreened ? 'Completed*' : 'Completed';
    return {
      label: i18n.t(`playerSurvey.${key}`, { defaultValue }),
      color: STATUS_COLORS[key],
    };
  }
  return { label: i18n.t(`playerSurvey.${pq.status}`, { defaultValue: pq.status }), color: STATUS_COLORS[pq.status] || '#555' };
};

export default class ASQSimpleSurveysRow extends React.PureComponent {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    playerId: PropTypes.number.isRequired,
    pqType: PropTypes.oneOf(['parent', 'teacher']).isRequired,
    survey: PropTypes.shape({
      id: PropTypes.number,
      ageRange: PropTypes.number,
      bankName: PropTypes.string,
      type: PropTypes.string,
      asqBankId: PropTypes.number,
      state: PropTypes.string,
      status: PropTypes.string,
      rescreened: PropTypes.bool,
      dateFinished: PropTypes.string,
      sections: PropTypes.array,
    }).isRequired,
    playerIdx: PropTypes.number.isRequired,
    onASQLink: PropTypes.func.isRequired,
  }

  onClick = (e) => {
    e.stopPropagation();
    const { playerId, survey, onASQLink, location, pqType } = this.props;
    onASQLink(playerId, survey.ageRange, survey.asqBankId, location, pqType, survey.id);
  }

  render() {
    const { survey, playerIdx } = this.props;
    const clsRow = classNames('o-rtable__row u-pointer', { 'cs-bg--sp-hover': playerIdx % 2 === 0 });
    const { label, color } = surveyStatusLabel(survey);

    return (
      <div className={clsRow} onClick={this.onClick}>
        <div className={`o-rtable__cell o-rtable__cell--age-bank cs-txt--${survey.type}`}>
          <div>{survey.ageRange} mo</div>
          <div>{survey.bankName}</div>
        </div>
        <div className='o-rtable__cell o-rtable__cell--date'>
          {formatDateUTC(survey.dateFinished)}
        </div>
        <div className='o-rtable__cell o-rtable__cell--score'>
          <ASQSectionResults survey={survey} />
        </div>
        <div className='o-rtable__cell o-rtable__cell--status'>
          {survey.state === 'archived'
            ? <ArchivedBadge color={color} />
            : <b style={{ color }}>{label}</b>
          }
        </div>
      </div>
    );
  }
}
